<template>
    <div
        class="app-main__wrapper"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {

    name: 'AppLayout',

    data () {
        return {

        };
    }
};
</script>

<style lang="scss">
    .app-main{
        &__wrapper{
            background-color: #1E1E1E;
            height: calc(100vh - 65px);
            width: calc(100vw - 229px);
            position: relative;
            top: 65px;
            left: 229px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/partials/app-layout.vue